// Feature: M001-F0225 (web slice), M001-D021 §16.1 Δ8. Test: T-CONN-0239.
//
// The approving administrator is shown the node's declared `local_base_url`
// (Core returns it in the device-link approval context). Core registers it as
// the approved sign-in origin in the completion transaction only when it is an
// EXACT https origin (Core `exactHttpsOrigin`: https, no credentials, path,
// query or fragment). This mirrors that rule for DISPLAY ONLY: the classification
// never gates the approval and is never sent back to Core.
export const describeNodeOrigin = (value) => {
  if (typeof value !== 'string' || !value.trim()) {
    return { declared: false, shown: '', exactHttps: false };
  }
  const raw = value.trim();
  let exactHttps = false;
  try {
    const url = new URL(raw);
    exactHttps = url.protocol === 'https:'
      && !url.username && !url.password && !url.search && !url.hash
      && url.pathname === '/'
      && !raw.includes('?') && !raw.includes('#')
      && raw.replace(/\/$/, '').toLowerCase() === url.origin.toLowerCase();
  } catch {
    exactHttps = false;
  }
  return { declared: true, shown: raw, exactHttps };
};
